import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  style: {"height":"100%"}
}
const _hoisted_3 = {
  key: 0,
  style: {"height":"80%"}
}
const _hoisted_4 = { class: "text-3xl antialiased font-mono text-gray-900" }
const _hoisted_5 = {
  key: 0,
  class: "text-m"
}
const _hoisted_6 = { class: "antaliased font-mono text-grey-700" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 2 }

import * as google_protobuf_empty_pb from "google-protobuf/google/protobuf/empty_pb";
import { Timestamp } from "google-protobuf/google/protobuf/timestamp_pb";
import * as grpcWeb from "grpc-web";
import { onMounted, Ref, ref } from "vue";
import { useRoute } from "vue-router";
import LogViewer from "../components/LogViewer.vue";
import { useClipboard } from "@vueuse/core";
import {
  GetJobLogEntriesRequest,
  GetJobLogRequest,
  JobLogState,
  JobLogStreamEntry,
} from "../joblog_pb";
import { JobLogViewerClient } from "../JoblogServiceClientPb";


export default /*@__PURE__*/_defineComponent({
  __name: 'Viewer',
  setup(__props) {

const jobLogFetchFinished = ref(false);
const jobLogExists = ref(false);

const jobLogName = ref("");
const jobLogDescription = ref("");
const jobLogState = ref(JobLogState.CREATED);
const client: Ref<JobLogViewerClient | null> = ref(null);
const tokenFetchFinished = ref(false);
let routerToken = useRoute().params.token as string;
let shortLivedToken = ref("");
const items = ref<any>([]);

// Keep track of the last entry read.
let after_entry_id = "0";

const { copy } = useClipboard();
const copyLog = () => {
  const text = items.value
    .map((entry: any) => entry.message as string)
    .join("\n");
  copy(text);
};

// The known viewer server hosts.
function getLogViewerHostFromIssuer(issuer: string): string {
  switch (issuer) {
    case "https://dev.joblog.warehouse.dev":
      return "http://localhost:50052";
    case "https://prod-europe.joblog.warehouse.dev":
      return "https://joblog.prod-europe.demarque.dev:443";
    case "https://prod-northamerica.joblog.warehouse.dev":
      return "https://joblog.prod-northamerica.demarque.dev:443";
    case "https://staging-northamerica.joblog.warehouse.dev":
      return "https://joblog.staging-northamerica.demarque.dev:443";
    default:
      return "https://joblog.prod-europe.demarque.dev:443";
  }
}

// Get the the log id and the job log server host from a token
function getLogIdAndHostFromToken(token: string): [string, string] {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  let decodedToken = JSON.parse(jsonPayload);
  let sub = decodedToken.sub as string;
  let issuer = decodedToken.iss as string;
  return [getLogViewerHostFromIssuer(issuer), sub];
}

// This function gets the token to be used to authenticate the user to the job log server and the client itself.
// The procedure is as follows:
// 1. gets the short lived token from the URL.
// 2. checks if there is already a long lived token that corresponds to the short lived token
//    in the local storage.
// 3. If there is none, exchange the short lived token for a long lived token from the job log server.
// 4. store the long lived token in the local storage (associated to the short lived token)
// 5. Return the long lived token.
async function getClientAndToken(): Promise<[JobLogViewerClient, string]> {
  if (routerToken != null && routerToken.length > 0) {
    shortLivedToken.value = routerToken;
  } else {
    if (window.location.hash && window.location.hash.length > 1) {
      shortLivedToken.value = window.location.hash.substring(1);
    }
  }

  if (shortLivedToken.value == null) {
    throw new Error("Failed to find short lived token");
  }

  let [host, jobLogId] = getLogIdAndHostFromToken(shortLivedToken.value);
  let storedLongLivedToken = localStorage.getItem(jobLogId);

  if (storedLongLivedToken == null) {
    console.log("no long lived token. fetching it.");
    const unauthorizedClient = new JobLogViewerClient(host, null, null);
    console.log("about to upgrade token");
    let reply = await unauthorizedClient.upgradeViewerToken(
      new google_protobuf_empty_pb.Empty(),
      { authorization: shortLivedToken.value }
    );
    console.log("about to get long lived token from response");
    let fetchedLongLivedToken = reply.getLonglivedtoken();
    console.log("fetched long lived token " + fetchedLongLivedToken);
    localStorage.setItem(jobLogId, fetchedLongLivedToken);
    storedLongLivedToken = fetchedLongLivedToken;
  }
  return [
    new JobLogViewerClient(host, { authorization: storedLongLivedToken }),
    storedLongLivedToken,
  ];
}

onMounted(async () => {
  try {
    let [c, token] = await getClientAndToken();
    client.value = c;
    let jobLogRequest = new GetJobLogRequest();
    let [_, jobLogId] = getLogIdAndHostFromToken(token);
    jobLogRequest.setId(jobLogId);
    const jobLog = await client.value.getJobLog(jobLogRequest, {
      authorization: token,
    });
    jobLogFetchFinished.value = true;
    jobLogName.value = jobLog.getName();
    jobLogDescription.value = jobLog.getDescription();
    jobLogState.value = jobLog.getState();
    jobLogFetchFinished.value = true;
    jobLogExists.value = true;
    tokenFetchFinished.value = true;

    let entriesRequest = new GetJobLogEntriesRequest();
    entriesRequest.setId(jobLogId as string);
    entriesRequest.setKeepopen(true);
    entriesRequest.setAfterid(after_entry_id);
    console.log("toklen");
    console.log(token);
    const stream = client.value.getLogEntries(entriesRequest, {
      authorization: token,
    });

    stream.on("status", (status: grpcWeb.Status) => {
      console.log("got status.");
      console.log(status);
    });

    stream.on("end", () => {
      console.log("stream end");
    });

    stream.on("data", (data: JobLogStreamEntry) => {
      if (data.hasEntry()) {
        const entry = data.getEntry();
        if (entry) {
          const message = entry.getMessage();
          console.log(entry.getClienttimestamp());
          const timestamp = entry.getClienttimestamp() as Timestamp;
          console.log(timestamp);
          const level = entry.getLevel();
          const id = entry.getId();
          if (message && timestamp) {
            const item = { message, timestamp, level, id };
            items.value.push(item);
            after_entry_id = id;
          }
        }
      } else {
        console.log("Data with ping.");
      }
    });
  } catch (e) {
    console.log("Failed to obtain data.");
    console.log(e);
  }
});

return (_ctx: any,_cache: any) => {
  return (!jobLogFetchFinished.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading"))
    : (client.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (jobLogExists.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h1", _hoisted_4, [
                  _createTextVNode(_toDisplayString(jobLogName.value) + " ", 1 /* TEXT */),
                  (jobLogState.value == _unref(JobLogState).FINISHED)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, " ( FINISHED ) "))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(jobLogDescription.value), 1 /* TEXT */),
                _createVNode(LogViewer, { entries: items.value }, null, 8 /* PROPS */, ["entries"]),
                _createElementVNode("button", { onClick: copyLog }, "Copy"),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex justify-end text-xs antialiased italic" }, " De Marque Inc. ", -1 /* HOISTED */))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (jobLogFetchFinished.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Failed to fetch the job log."))
                  : _createCommentVNode("v-if", true)
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, "No job log identifier."))
}
}

})